import { lazy, Suspense } from 'react';

const QAQuickMenuLazy = lazy(
  () => import(/* webpackChunkName: "QAQuickMenu" */ './QAQuickMenu')
);

export default function QAQuickMenu() {
  if (
    ['development', 'qa', 'sandbox'].includes(process.env.REACT_APP_ENV ?? '')
  ) {
    return (
      <Suspense fallback={null}>
        <QAQuickMenuLazy />
      </Suspense>
    );
  }

  return null;
}
